import React from 'react'

const Home = () => {
  return (
    <div>
      <h1>Welcome to Product Manager</h1>
      <br />

      <ul>
        <li>Use <b>|</b> to separate or break Line in description.</li>
        <li>Use <b>**content**</b> to bold the content.</li>
      </ul>

      <h3>Blog Posting Rules</h3>
      <ul>
        <li><b>Always select the correct Website</b> before submitting.</li>
        <li><b>Title must be clear</b> and related to the blog topic.</li>
        <li>Slug should be <b>SEO-friendly</b> (lowercase-with-hyphens).</li>
        <li>Use the Editor to add formatted content — no plain text blogs.</li>
        <li>Upload images using the <b>"Upload New Image"</b> input.</li>
        <li>Use only <b>optimized images (under 300–500 KB)</b>.</li>
        <li>Do NOT paste images directly into the editor — always use Upload.</li>
        <li>Add at least:
          <ul>
            <li><b>Meta Title</b> (60 characters max)</li>
            <li><b>Meta Description</b> (160 characters max)</li>
            <li><b>Meta Keywords</b> (comma separated)</li>
          </ul>
        </li>
        <li>Use <b>H2 and H3 headings</b> for better SEO structure.</li>
        <li>Do not leave blank sections or dummy text like “Lorem ipsum”.</li>
        <li>Before saving, click <b>Preview</b> inside editor to check formatting.</li>
        <li>Once published, verify that the blog opens correctly on the website.</li>
      </ul>
    </div>
  )
}

export default Home
